import Layout from "components/Layout";
import React from "react";
import ManualDataTable from "./components/ManualDataTable";

function AdminManual() {
  return (
    <Layout title="매뉴얼 목록">
      <ManualDataTable />
    </Layout>
  );
}

export default AdminManual;
